<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" >

  <div fxLayout="column" fxFlex="100" class="print" >

      <div>
        <h1 class="p-20"><strong>Detalle del match</strong></h1>
      </div>

      <div fxLayout="column" class="p-20">

        <div fxFlex fxLayout="row" class="p-10">
            <div fxFlex="70"><strong>Regla Base: </strong>{{LOCAL_DATA.reglaBase.nombre}}</div>
            

        </div>
        <div fxFlex fxLayout="row" class="p-10">
          <div fxFlex="70"><strong>Mandato: </strong>{{LOCAL_DATA.mandato.nombre}}</div>  
          <div fxFlex="70"><strong>Mandato descripción: </strong>{{LOCAL_DATA.mandato.descripcion}}</div>
            <div fxFlex="70"><strong>Mandato Palabras clave: </strong>
              <span *ngFor="let palabra of LOCAL_DATA.mandato.palabrasClave; let isLast=last">{{palabra}} {{isLast ? '' : ', '}}</span>
            </div>
        </div>
        <div fxFlex fxLayout="row" class="p-10">
          <div fxFlex="70"><strong>Sub-mandato: </strong>{{LOCAL_DATA.subMandato.nombre}}</div>  
          <div fxFlex="70"><strong>Sub-mandato descripción: </strong>{{LOCAL_DATA.subMandato.descripcion}}</div>
            <div fxFlex="70"><strong>Sub-mandato Palabras clave: </strong>
              <span *ngFor="let palabra of LOCAL_DATA.subMandato.palabrasClave; let isLast=last">{{palabra}} {{isLast ? '' : ', '}}</span>
            </div>
        </div>
        
      </div>

      <div fxLayout="column" fxFlex="100">
        <div class="content" fxFlex="100" fxLayout="row">
      
            <div fxFlex class="content p-20">
              <table mat-table [dataSource]="LOCAL_DATA.cumplimiento" #tableProbabilidad class="my-table mat-elevation-z8 select-list" fxFlex>
      
                <ng-container matColumnDef="evaluacion">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Evaluacion</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{element.evaluacion}}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="control">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Control</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{element.control}}</span>
                  </td>
                </ng-container>

                <ng-container matColumnDef="resultado">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Coincidencias</th>
                  <td mat-cell *matCellDef="let element">
                    <table mat-table [dataSource]="element.matchs" #tableProbabilidad class="my-table mat-elevation-z8 select-list" fxFlex>

                      <ng-container matColumnDef="palabra" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Palabra</th>
                        <td mat-cell *matCellDef="let element">
                          <span >{{element.palabra}} </span>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="clave" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Clave</th>
                        <td mat-cell *matCellDef="let element">
                          <span >{{element.clave}} </span>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="valor" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor de coincidencia</th>
                        <td mat-cell *matCellDef="let element">
                          <span >{{element.valor}} </span>
                        </td>
                      </ng-container>


                      <tr mat-header-row *matHeaderRowDef="displayedColumnsMatchs"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsMatchs;"></tr>
                    </table>
                  </td>
                </ng-container>

                <ng-container matColumnDef="valor">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor</th>
                  <td mat-cell *matCellDef="let element">
                    <span>{{element.valor | number:'1.2-2'}}</span>
                  </td>
                </ng-container>

                
      
                <tr mat-header-row *matHeaderRowDef="displayedColumns" class="print" ></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="print" ></tr>
              </table>
            </div>
      
        </div>

  </div>
</div>


<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cerrar' | translate}}</button>
</div>
